import { GetDeliveryTemplate, YorN } from 'ncp-api-supporter';
import {OptionData} from '@/pro/helpers/type';

export const selectOption: OptionData<YorN>[] = [
  { value: 'Y', name: 'PRO_PRODUCT_ADD_DELIVERY_Y' },
  { value: 'N', name: 'PRO_PRODUCT_ADD_DELIVERY_N' },
];

export interface DefaultDeliveryTemplate extends Partial<GetDeliveryTemplate> {
  deliveryTypeLabel?: string;
}
export const defaultDeliveryTemplate: DefaultDeliveryTemplate = {
  // deliveryType: '',
  deliveryTypeLabel: '',
  // deliveryCompanyType: '',
  deliveryFee: {
    deliveryConditionType: null,
    deliveryConditionTypeLabel: '',
    deliveryAmt: 0,
    returnDeliveryAmt: 0,
  },
  releaseWarehouse: {
    substitutionText: '',
    address: {
      addressStr: '',
    },
  },
  returnWarehouse: {
    substitutionText: '',
    address: {
      addressStr: '',
    },
  },
};
